/* Stylesheet */

.outline_button {
  height: 42px;
  min-width: 108px;
  text-transform: none;
  --background: transparent;
  box-shadow: var(--ion-box-shadow);
  overflow: hidden;
  border-radius: 36px;
}
